const DEFAULT_FAILURE_ACTION = Object.freeze({
  messageType: 'error',
  messageKey: 'form.messages.createFailed',
  shouldRedirectToPay: false
})

const FAILURE_ACTION_MAP = Object.freeze({
  quota_block: {
    messageType: 'warning',
    messageKey: 'categoryForm.messages.noQuota',
    shouldRedirectToPay: true
  },
  quota_failed: {
    messageType: 'error',
    messageKey: 'categoryForm.messages.quotaFailed',
    shouldRedirectToPay: false
  },
  file_not_ready: {
    messageType: 'warning',
    messageKey: 'categoryForm.messages.fileNotReady',
    shouldRedirectToPay: false
  }
})

const FAILURE_EVENT_MARKER_MAP = Object.freeze({
  quota_block: 'funnel_quota_block'
})

export function resolveTranslationStartFailureAction(reason) {
  if (typeof reason !== 'string') {
    return DEFAULT_FAILURE_ACTION
  }

  return FAILURE_ACTION_MAP[reason] || DEFAULT_FAILURE_ACTION
}

export function handleTranslationStartFailureContract({ reason, localePath } = {}) {
  const failureAction = resolveTranslationStartFailureAction(reason)
  const resolvePath = typeof localePath === 'function' ? localePath : (path) => path

  return {
    failureAction,
    messageType: failureAction.messageType,
    messageKey: failureAction.messageKey,
    shouldRedirectToPay: failureAction.shouldRedirectToPay,
    redirectPath: failureAction.shouldRedirectToPay ? resolvePath('/pay') : null,
    eventMarker: FAILURE_EVENT_MARKER_MAP[reason] || null
  }
}

export async function applyTranslationStartFailureAction({
  failureAction,
  redirectPath,
  router,
  localePath,
  t,
  showWarning,
  showError
}) {
  const action = failureAction || DEFAULT_FAILURE_ACTION
  const translate = typeof t === 'function' ? t : (key) => key
  const warning = typeof showWarning === 'function' ? showWarning : () => {}
  const error = typeof showError === 'function' ? showError : () => {}
  const resolvePath = typeof localePath === 'function' ? localePath : (path) => path

  const message = translate(action.messageKey)
  if (action.messageType === 'warning') {
    warning(message)
  } else {
    error(message)
  }

  if (!action.shouldRedirectToPay) {
    return
  }

  if (!router || typeof router.push !== 'function') {
    throw new Error('applyTranslationStartFailureAction requires router.push when redirect is enabled')
  }

  const nextPath = typeof redirectPath === 'string' && redirectPath.length > 0
    ? redirectPath
    : resolvePath('/pay')

  await router.push(nextPath)
}
